import { render } from "./upIphone.vue?vue&type=template&id=044060e2&scoped=true"
import script from "./upIphone.vue?vue&type=script&lang=js"
export * from "./upIphone.vue?vue&type=script&lang=js"

import "./upIphone.vue?vue&type=style&index=0&id=044060e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044060e2"]])

export default __exports__